import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';

import { NgScrollbar } from 'ngx-scrollbar';
import {
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  lastValueFrom,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import { CfgQuestionarioComponent } from 'src/app/components/cfg-questionario/cfg-questionario.component';
import { CfgStampaComponent } from 'src/app/components/cfg-stampa/cfg-stampa.component';
import { CompilaReportVsmeComponent } from 'src/app/components/compila-report-vsme/compila-report-vsme.component';
import { CustomSnackbarComponent } from 'src/app/components/custom-snackbar/custom-snackbar.component';
import { DialogSelezioneDocumentiPerAiComponent } from 'src/app/components/dialog-selezione-documenti-per-ai/dialog-selezione-documenti-per-ai.component';
import {
  InclusioneModuliComponent,
  ModuliInclusi,
  ModuliPubblicati,
} from 'src/app/components/inclusione-moduli/inclusione-moduli.component';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { DialogAssociaFiguraAziendaleComponent } from 'src/app/components/selezione-elementi-questionario/dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DATA_SERVICE } from 'src/app/components/totali-cruscotto/data-service.token';
import { TotaliCruscottoComponent } from 'src/app/components/totali-cruscotto/totali-cruscotto.component';
import { DialogCreaTemplateMailComponent } from 'src/app/page/analisi-materialita/materialita/dialog/dialog-crea-template-mail/dialog-crea-template-mail.component';
import { InfoFormVsmeComponent } from 'src/app/page/aziende/dialog/dialog-crea-azienda/info-form-vsme/info-form-vsme.component';
import { DialogAnteprimaCompilazioneInfoAzComponent } from 'src/app/page/configurazioni/cfg-informativa-aziendale/dialog/dialog-anteprima-compilazione-info-az/dialog-anteprima-compilazione-info-az.component';
import { DialogCompilazioneFigureComponent } from 'src/app/page/sintesi-sostenibilita/dialog/dialog-compilazione-figure/dialog-compilazione-figure.component';
import { Azienda, AziendaService, InfoFormVsme } from 'src/app/services/azienda/azienda.service';
import { GruppoCfgStampa } from 'src/app/services/config-stampe/config-stampe.service';

import { FolliaWidgetStoreService } from 'src/app/services/follia-widget/follia-widget-store.service';
import { ImportazioniService } from 'src/app/services/importazioni/importazioni.service';
import { Nace, Paese } from 'src/app/services/json-file/json-file.service';
import {
  CompilaTematiche,
  ReportVsme,
  ReportVsmeService,
} from 'src/app/services/report-vsme/report-vsme.service';
import { Settore, SettoriService, SottoSettore } from 'src/app/services/settori/settori.service';
import { ElementiCruscotto } from 'src/app/services/sintesi/sintesi.service';
import { TemaService } from 'src/app/services/tema/tema.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialog-crea-report-vsme',
  standalone: false,

  templateUrl: './dialog-crea-report-vsme.component.html',
  styleUrl: './dialog-crea-report-vsme.component.scss',
  providers: [{ provide: DATA_SERVICE, useClass: ReportVsmeService }],
})
export class DialogCreaReportVsmeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('btnAvanti') btnAvanti!: MatButton;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild('infoFormVsme') infoFormVsmeCMP!: InfoFormVsmeComponent;
  @ViewChild('cmpCompilaVsme') cmpCompilaVsme!: CompilaReportVsmeComponent;
  @ViewChild(CfgQuestionarioComponent) componenteSurvey!: CfgQuestionarioComponent;
  @ViewChild('scrollConfStampa') scrollConfStampa!: NgScrollbar;
  @ViewChild(CfgStampaComponent) cfgStampaComponent!: CfgStampaComponent;
  @ViewChild(InclusioneModuliComponent) inclusioneModuli!: InclusioneModuliComponent;
  @ViewChild('totaliCruscotto') cmpTotaliCruscotto!: TotaliCruscottoComponent;

  /***************************** FORM REPORT VSME ******************************************************/
  public formReportVsme = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    idAzienda: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    anno: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    nrDipendenti: new FormControl<number | undefined>(undefined, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.min(0),
        Validators.pattern('^[0-9]*$'),
        Validators.max(999999999999),
      ],
    }),

    fatturato: new FormControl<number>(0, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.min(0),
        Validators.max(999999999999),
      ],
    }),

    tipo: new FormControl<string>('REPORT_VSME', {
      nonNullable: true,
      validators: [],
    }),
    tipoVsme: new FormControl<'BASE' | 'COMPLETO'>('BASE', {
      nonNullable: true,
      validators: [],
    }),
    settori: new FormControl<Settore | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),
    tipoAzienda: new FormControl<'MICROIMPRESA' | 'PMI' | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    selectedFolderIds: new FormControl<string[]>([], {
      nonNullable: true,
      validators: [],
    }),
  });

  /**********************************  VARIABILI GLOBALI ******************************************************/
  private _reportVsme: any = {};

  /* Id del report VSME: in modifica è quello esistente, in creazione viene generato
  lato client e poi inviato al backend nella POST di creazione (step 1) */
  private readonly _idReportCorrente: string;

  get reportVsme() {
    return this._reportVsme;
  }

  get idReportVsme() {
    return this.formReportVsme.get('id')?.value ?? this.data?.reportVsme?.id ?? '';
  }

  get isIntegrazioneAI() {
    return this.data?.integrazioneIA ?? false;
  }

  /* Il widget è dichiarato nel template della dialog (e non in app.component) così partecipa
  allo stacking context del cdk-overlay-container: tooltip e menu aperti dopo restano sopra il widget */
  get showChatWidget() {
    return this.widgetStore.showChatWidget();
  }
  public isUtenteGo: boolean = false;
  private _subTema: Subscription | undefined;

  /* STEP 1 VSME */

  public idModuliInclusi: ModuliInclusi | undefined;
  public mostraBottoneAssegnazioni: boolean = false;
  public arrayAnni: string[] = [];
  public filteredNace: Observable<Nace[]> | undefined;
  private _datiAzienda: Azienda | undefined = undefined;
  public datiAziendaVsme: InfoFormVsme | undefined = undefined;
  public showInfoFormVsme: boolean = false;
  private numeroDipendetiAzienda: number = 0;
  private numeroFatturatoAzienda: number = 0;
  public idQuestionario: string | undefined = undefined;
  public arraySottoSettori: SottoSettore[] = [];
  public mappaAnnoSettore: { [anno: string]: { [settore: string]: boolean } } = {};

  /* INFORMATIVA AZIENDALE */
  public isPermessoInvioMail: boolean = this.utenteService.isPermessoAttivo('INVIO_MAIL');
  public displayedColumns: string[] = ['figura', 'nome', 'email', 'stato', 'azioni'];
  public arrayInformativa: any[] = [];

  /* COMPIILAZIONE RISPOSTE TEMATICHE  */

  public compilaTematiche: CompilaTematiche | undefined = undefined;

  public guidaDescrizione: string | undefined = undefined;

  private readonly widgetStore = inject(FolliaWidgetStoreService);

  private readonly snackBar = inject(MatSnackBar);

  /******************************************** CRUSCOTTO SURVEY *************************************/
  @ViewChild('tabellaCruscotto') tabellaCruscotto!: ListaTabellareComponent;
  public filtri: Filtri[] = [
    {
      titolo: 'Figure Aziendali',
      forControlName: 'figureAziendali',
      input: 'text',
    },
    {
      titolo: 'Nome',
      forControlName: 'nome',
      input: 'text',
    },
    {
      titolo: 'Cognome',
      forControlName: 'cognome',
      input: 'text',
    },
    {
      titolo: 'Email',
      forControlName: 'email',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    stakeholder: {
      title: 'Figure Aziendali',
      value: 'figura',
    },
    tipologia: {
      title: 'Nome',
      value: 'nome',
    },
    email: {
      title: 'Email',
      value: 'email',
    },
    stato: {
      title: 'Stato',
      value: (record: any) => {
        if (record?.stato === 'ROSSO') {
          // non compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#cf5b61;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'GIALLO') {
          // ha inviato la mail ma non è stato compilato (valore solo per gli stakeholder con modalita compilazione "INVIAMAIL")
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#c7a045;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'VERDE') {
          // compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#729373;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else {
          return '';
        }
      },
    },
    history: {
      type: 'button',
      buttonIcon: this.isPermessoSoloReadFunx() ? 'visibility' : 'history_edu',
      title: this.isPermessoSoloReadFunx() ? 'Visualizza' : 'Compila',
      buttonId: 'compila',
      buttonMostraSempre: true,
      sortable: false,
    },

    modifica: {
      type: 'button',
      buttonIcon: 'person_edit',
      title: 'Modifica',
      buttonId: 'modifica',
      nascondiButton: (record) => record?.stato === 'VERDE' || this.isPermessoSoloReadFunx(),
      buttonMostraSempre: true,
    },
  };

  /********************************** CONSTRUCTOR ******************************************************/
  constructor(
    public dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<DialogCreaReportVsmeComponent>,
    private readonly utilityService: UtilityService,
    readonly aziendaService: AziendaService,
    private readonly utenteService: UtenteService,
    private readonly reportVsmeService: ReportVsmeService,
    private readonly settoriService: SettoriService,
    private readonly importazioniService: ImportazioniService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly temaService: TemaService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      reportVsme: ReportVsme;
      ctrAnniCreati: string[];
      integrazioneIA: boolean;
    },
  ) {
    // In modifica uso l'id del modulo esistente, in creazione genero l'id lato client
    // (formato ObjectId di MongoDB: 24 caratteri esadecimali, un UUID non è valido)
    this._idReportCorrente = data.reportVsme?.id ?? this.utilityService.generaObjectId();

    if (data.reportVsme?.id) {
      this.idModuliInclusi = {
        idMaterialita: data.reportVsme?.idMaterialita,
        idDoppiaMaterialita: data.reportVsme?.idDoppiaMaterialita,
        idSintesiSostenibilita: data.reportVsme?.idSintesiSostenibilita,
        idAutovalutazioneCompilata: data.reportVsme?.idAutovalutazioneCompilata,
        idPolicySostenibilita: data.reportVsme?.idPolicySostenibilita,
        idPianoSostenibilita: data.reportVsme?.idPianoSostenibilita,
        idBilancioSostenibilita: data.reportVsme?.idBilancioSostenibilita,
      };
    }

    //Visualizza chat AI FOLLIA
    if (this.isIntegrazioneAI) {
      // Imposto la chiave di isolamento dello storico chat PRIMA di montare il widget,
      // così l'auth (getJWTFollia) parte già con il valore corretto invece che null.
      // Per i report VSME la chiave è l'id del modulo: ogni modulo ha il suo storico
      this.widgetStore.setIdStoricoChat(this._idReportCorrente);

      if (data.reportVsme?.idDatasourceAi) {
        this.widgetStore.setIdDatasourceAi(data.reportVsme.idDatasourceAi);
      }

      //! da rimuovere appena FOLLIA è ALLINEATA
      this.widgetStore.setIdDatasourceDefault(environment.dataSourceDefault);

      // Mostro il widget solo dopo che la dialog è stata aperta e renderizzata
      this.dialogRef
        .afterOpened()
        .pipe(take(1))
        .subscribe(() => {
          this.widgetStore.showChatWidget.set(true);
        });
    }
  }

  /* Messaggio in signal per snackbar live */
  private readonly liveMessage = signal('');
  /* snackbar ref custom per la chiusura */
  private snackBarRef: MatSnackBarRef<CustomSnackbarComponent> | null = null;

  /**
   * Mostra uno snackbar con un messaggio dinamico per i file che si stanno caricando
   * su Follia
   * viene aperto per l'evento signal isLoadingFileFollia() che viene valorizzato nel
   * metodo ricorsivo della chiamata dei jobs per vedere lo stato dei file.
   * Il metodo viene chiamato nel salvataggio del report vsme
   *
   */
  private readonly checkStatusFile = effect(() => {
    const isLoading = this.widgetStore.isLoadingFileFollia();
    const fileCaricati = this.widgetStore.fileCaricati();

    if (isLoading) {
      // 1. Aggiorno il messaggio
      this.liveMessage.set('Caricamento files in corso: (' + fileCaricati + ')');

      // 2. Apri se non già aperta
      if (!this.snackBarRef) {
        this.snackBarRef = this.utilityService.openLiveSnackBar(this.liveMessage, 'white-snackbar');

        // Opzionale: pulizia se l'utente chiude la snackbar manualmente (cliccando fuori o tasto X)
        this.snackBarRef.afterDismissed().subscribe(() => {
          this.snackBarRef = null;
        });
      }
    } else {
      // 3. Caso: Caricamento finito
      if (this.snackBarRef) {
        this.liveMessage.set('Caricamento completato!');

        setTimeout(() => {
          this.snackBarRef?.dismiss();
          this.snackBarRef = null;
        }, 2000);
      }
    }
  });

  ngOnInit(): void {
    const annoCorrente = new Date().getFullYear();
    // Aggiungi gli anni indietro di 5 anni e in avanti di 1 anno all'array
    for (let i = annoCorrente - 5; i <= annoCorrente + 1; i++) {
      this.arrayAnni.push(i.toString());
    }

    // Aggiungo l'anno di un modulo precedente agli anni calcolati.
    // Se ho creato un modulo di ques'anno allora tramite questa gestione l'anno prossimo riuscirò a viusalizzarlo

    if (this.data.reportVsme) {
      const { anno } = this.data.reportVsme;
      if (anno && !this.arrayAnni.includes(anno)) {
        this.arrayAnni.push(anno);
      }
    }
    this.ctrIsUtenteGo();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.init();
      this.cdRef.detectChanges();
    }, 0);

    this.gestioneStepper();
    this._gestioneStatoSteps();

    if (!this.data.reportVsme?.id) {
      this._onChangeTipoAzienda();
    }
  }

  ngOnDestroy(): void {
    this._subTema?.unsubscribe();
    //Visualizza chat AI FOLLIA
    this.widgetStore.showChatWidget.set(false);
  }

  private _onChangeTipoAzienda() {
    const tipoAzienda = this.formReportVsme.get('tipoAzienda');

    tipoAzienda?.valueChanges.subscribe((value) => {
      this._consigliaSelezioneTipoImpresaPmi(value);
    });
  }

  private _consigliaSelezioneTipoImpresaPmi(tipoAzienda: 'MICROIMPRESA' | 'PMI' | undefined) {
    this.guidaDescrizione = '';
    switch (tipoAzienda) {
      case 'MICROIMPRESA':
        this.formReportVsme.get('tipoVsme')?.setValue('BASE');
        this.guidaDescrizione =
          'Selezionando Microimpresa, è consigliato trattare il modulo in versione Base ';

        break;
      case 'PMI':
        this.formReportVsme.get('tipoVsme')?.setValue('COMPLETO');
        this.guidaDescrizione =
          'Selezionando PMI, è consigliato trattare il modulo in versione Completa';

        break;

      default:
        break;
    }
  }

  /**
   * Metodo iniziale nella generazione del componente di creazione modulo Vsme
   * @returns
   */
  async init() {
    const reportVsme = this.data?.reportVsme;

    if (!reportVsme?.id) {
      await this._valorizzaSettoreGenerico();

      this.getDatiAzienda();

      return;
    }

    await this._setDatiVsme(reportVsme);

    await this.getGenericPrompt();
  }

  private _abilitaBottoneAvanti() {
    if (this.btnAvanti) this.btnAvanti.disabled = false;
  }

  onSelectionChangeAnno(event: MatSelectChange) {}

  /**
   * Setta nel formGroup i dati del VSME
   * @param reportVsme
   */
  private async _setDatiVsme(reportVsme: ReportVsme) {
    Object.keys(reportVsme).forEach((value) => {
      if (value === 'settori') {
        this.formReportVsme.get('settori')?.setValue((reportVsme as any)[value][0]);
      } else {
        this.formReportVsme.get(value)?.setValue((reportVsme as any)[value]);
      }
    });

    this.datiAziendaVsme = {
      codiciNace: reportVsme.codiciNace,
      formaGiuridica: reportVsme.formaGiuridica as any,
      paeseOperazioni: reportVsme.paeseOperazioni,
      statoPatrimoniale: reportVsme.statoPatrimoniale,
      tabellaSiti: reportVsme.tabellaSiti,
      tipoAzienda: reportVsme.tipoAzienda,
    };

    this.showInfoFormVsme = true;

    this.formReportVsme.disable();

    // Se ho un id data source allora lo imposto per il widget FOLLIA
    if (reportVsme?.idDatasourceAi) {
      this.widgetStore.setIdDatasourceAi(reportVsme.idDatasourceAi);
    }
  }

  /**
   * Valorizzo il settore sulla form, sarà sempre generale
   */
  private async _valorizzaSettoreGenerico() {
    if (this.data.reportVsme?.settori?.length) {
      this.formReportVsme.get('settori')?.setValue(this.data.reportVsme.settori[0]);
    } else {
      const settoreGenerico: Settore | undefined = await this._getSettoreGenerale();
      if (settoreGenerico) {
        this.formReportVsme.get('settori')?.setValue(settoreGenerico);
      }
    }
  }

  getDatiAzienda() {
    this.spinnerOver.show();
    this.aziendaService.azienda.then((azienda) => {
      if (azienda) {
        this.formReportVsme.get('idAzienda')?.setValue(azienda.id);

        this.aziendaService
          .getAziendaByIdAzienda(azienda.id)
          .pipe(finalize(() => this.spinnerOver.hide()))
          .subscribe((risp: Azienda) => {
            this._datiAzienda = risp;

            if (!this.reportVsme?.id) {
              this.formReportVsme
                .get('tipoAzienda')
                ?.setValue(this._datiAzienda?.tipoAzienda ?? 'MICROIMPRESA');
            }

            if (!this.data?.reportVsme?.id) {
              this.mappaFormDaAzienda(risp);
              this.showInfoFormVsme = true;
            }
          });
      }
    });
  }

  private async _getSettoreGenerale(): Promise<Settore | undefined> {
    try {
      const forkRisp = await firstValueFrom(
        forkJoin({
          generale: this.settoriService.getSettoreGenerale().pipe(
            catchError((err) => {
              console.error('ERRORE GET SETTORE GENERALE : ', err);
              // Errore recupero settore generale, potrebbe non esistere. Si torna undefined
              return of(undefined);
            }),
          ),
          vsmeCreati: this.reportVsmeService.getReportVsme(0, 1000, '', []).pipe(
            catchError((err) => {
              console.error('ERRORE GET BILANCI CREATI : ', err);
              return of(undefined);
            }),
          ),
        }),
      );

      /* if (forkRisp?.vsmeCreati?.content) {
        this.mappaAnnoSettore = this.settoriService.getModuliDaCreare(
          forkRisp?.vsmeCreati?.content,
        );
      } */
      return forkRisp?.generale;
    } catch (error) {
      console.error(error);

      this.spinnerOver.hide();

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero dei settori',
        bottoni: [{ nome_btn: 'Ok' }],
      });

      this.dialogRef.close();
      return undefined;
    }
  }

  mappaFormDaAzienda(azienda: Azienda) {
    this.numeroDipendetiAzienda = azienda.dipendenti;
    this.numeroFatturatoAzienda = azienda.fatturato;
    this.formReportVsme.get('nrDipendenti')?.setValue(this.numeroDipendetiAzienda);
    this.formReportVsme.get('fatturato')?.setValue(this.numeroFatturatoAzienda);

    // oggetto dati azienda vsme che viene assegnato al componente figlio
    const aziendaCopy = JSON.parse(JSON.stringify(azienda));
    this.datiAziendaVsme = {
      codiciNace: aziendaCopy.codiciNace,
      formaGiuridica: aziendaCopy.formaGiuridica,
      paeseOperazioni: aziendaCopy.paeseOperazioni,
      statoPatrimoniale: aziendaCopy.statoPatrimoniale,
      tabellaSiti: aziendaCopy.tabellaSiti,
      tipoAzienda: aziendaCopy.tipoAzienda,
    };
  }

  onKeyDown(event: KeyboardEvent): void {
    // Verifica se il tasto premuto è il carattere "-"
    if (event.key === '-') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  onKeyDownDip(event: KeyboardEvent): void {
    if (event.key === ',' || event.key === '.') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  /**
   * Controlla se l'anno passatto è gia stato utilizzato
   * @param anno
   * @returns
   */
  ctrAnniUtilizzati(anno: string): boolean {
    return this.data.ctrAnniCreati.includes(anno);
  }

  /**
   * Questionario pubblicato
   * @returns true === PUBBLICATO
   */
  public isPubblicato(): boolean {
    return (
      this._reportVsme?.stato === 'PUBBLICATO' || this.data?.reportVsme?.stato === 'PUBBLICATO'
    );
  }
  public isArchiviato(): boolean {
    return (
      this._reportVsme?.stato === 'ARCHIVIATO' || this.data?.reportVsme?.stato === 'ARCHIVIATO'
    );
  }

  isPermessoSoloReadFunx() {
    const isEdit = this.utenteService.isPermessoAttivo('EDIT_VSME');
    const isCreate = this.utenteService.isPermessoAttivo('CREATE_VSME');
    return (!isEdit && !isCreate) || this.isArchiviato();
  }

  protected isPermessoStama = this.utenteService.isPermessoAttivo('STAMPA');

  /**
   * Viene disabilitato per non spammare il bottone avanti mentre stanno caricando i dati
   */
  disabilitaBottoneAvanti() {
    setTimeout(() => {
      this.btnAvanti.disabled = true;
    }, 0);
  }

  cambioStep(event: StepperSelectionEvent) {
    this.mostraBottoneAssegnazioni = false;

    if (event.selectedIndex === 0) {
      // step1
    } else if (event.selectedIndex === 1) {
      this._getInformativa();
    } else if (event.selectedIndex === 2) {
      this.disabilitaBottoneAvanti();
      return this._getStepTematiche();
    } else if (event.selectedIndex === 3) {
      return this._getDatiCompilazioneTematiche();
    } else if (event.selectedIndex === 4) {
      this.spinnerOver.show();
      this.tabellaCruscotto.caricaDati();
      this.spinnerOver.hide();
      this.cmpTotaliCruscotto.getTotaliCruscotto();
    } else if (event.selectedIndex === 5) {
      return this.cfgStampaComponent.caricaStampa();
    }
  }

  /**
   * Bottone indietro
   * @returns step precedente
   */
  indietro() {
    switch (this.stepper.selectedIndex) {
      case 0:
        return true;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        this._moveInStep(this.stepper.selectedIndex - 1);
        return true;
      default:
        return null;
    }
  }

  /**
   * Bottone avanti
   * @returns metodo in base allo step attuale
   */
  public async avanti() {
    let result: boolean = false;
    this.spinnerOver.show();

    switch (this.stepper.selectedIndex) {
      case 0:
        result = await this.salvaStepVSME();

        break;
      case 1:
        result = await this.isInformativaCompilata();
        break;
      case 2:
        result = await this.salvaStepTematiche();
        if (result && this.componenteSurvey.objMotivazioneTematicaVSME?.length) {
          this.reportVsmeService
            .salvaMotivazioneTematica(
              this.formReportVsme.get('id')?.value ?? '',
              this.componenteSurvey.objMotivazioneTematicaVSME,
            )
            .subscribe();
        }
        break;
      case 3:
        if (this.isPubblicato() || this.isArchiviato()) {
          result = true;
        } else {
          const isValid = await this.cmpCompilaVsme.validaCompilazione();

          if (isValid) {
            result = await this.cmpCompilaVsme.salvaCompilazione();
          }
        }

        break;
      case 4:
        if (!this.isPubblicato() && !this.isArchiviato()) {
          const risultatoObservable = await this._pubblicazioneReportVsme('alla stampa');
          if (risultatoObservable) {
            const risultato = await firstValueFrom(risultatoObservable);
            this.spinnerOver.hide();
            if (!risultato) {
              return;
            }
          }
        }

        return true;
      default:
        return;
    }
    this.spinnerOver.hide();

    return result;
  }

  public async avantiHTML() {
    if (this.isPermessoSoloReadFunx() || (await this.avanti())) {
      this._gestioneStatoStepperAvanti();

      return this.stepper.next();
    }
  }

  /**
   * Metodo salvataggio STEP 1 VSME
   * @returns
   */
  public async salvaStepVSME(): Promise<boolean> {
    const idReportVsme = this.formReportVsme.get('id')?.value;

    // 1. Check se già salvato
    if (idReportVsme) {
      return true;
    }

    // 2. Validazione Form
    if (this.formReportVsme.invalid) {
      Object.values(this.formReportVsme.controls).forEach((control) => {
        control.markAsTouched();
      });
      return false;
    }

    // 3. Conferma Utente
    const aggiornaDatiAzienda = await this.ctrDatiAziendaChanged();
    const dialog = this.utilityService.openDialog({
      titolo: `Creazione Report VSME`,
      descrizione: 'Continuando non sarà più possibile modificare queste informazioni.',
      bottoni: [
        { nome_btn: 'Annulla', id_btn: 'N' },
        { nome_btn: 'Avanti', id_btn: 'S' },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return false;
    }

    // 4. Preparazione Dati
    // L'id è quello generato lato client all'apertura della dialog (già usato per l'auth Follia)
    // e viene inviato al backend che lo usa come id del documento.
    // Va nel form solo dopo il successo della POST: se restasse valorizzato dopo un errore,
    // il check iniziale "già salvato" salterebbe la creazione al tentativo successivo.
    const formCrtSostenibilita = {
      ...this.formReportVsme.getRawValue(),
      id: this._idReportCorrente,
    };
    const formDatiAziendaVsme = this.infoFormVsmeCMP.formInfoVsme.getRawValue();
    const tabellaSiti = this.infoFormVsmeCMP.tabellaSitiCmp.salva();
    const inclusioneModuli = this.inclusioneModuli?.formInclusioneModuli;

    const formVsmeAndAzienda = {
      ...formCrtSostenibilita,
      codiciNace: [(formDatiAziendaVsme.codiciNace as Nace)._id],
      formaGiuridica: formDatiAziendaVsme.formaGiuridica,
      paeseOperazioni: [(formDatiAziendaVsme.paeseOperazioni as Paese).countryCode],
      statoPatrimoniale: formDatiAziendaVsme.statoPatrimoniale,
      tabellaSiti: tabellaSiti,
      idMaterialita: (inclusioneModuli?.get('idMaterialita')?.value as ModuliPubblicati)?.id,
      idDoppiaMaterialita: (inclusioneModuli?.get('idDoppiaMaterialita')?.value as ModuliPubblicati)
        ?.id,
      idSintesiSostenibilita: (
        inclusioneModuli?.get('idSintesiSostenibilita')?.value as ModuliPubblicati
      )?.id,
      idAutovalutazioneCompilata: (
        inclusioneModuli?.get('idAutovalutazioneCompilata')?.value as ModuliPubblicati
      )?.id,
      idPolicySostenibilita: (
        inclusioneModuli?.get('idPolicySostenibilita')?.value as ModuliPubblicati
      )?.id,
      idPianoSostenibilita: (
        inclusioneModuli?.get('idPianoSostenibilita')?.value as ModuliPubblicati
      )?.id,
      idBilancioSostenibilita: (
        inclusioneModuli?.get('idBilancioSostenibilita')?.value as ModuliPubblicati
      )?.id,
      aggiornaDatiAzienda: aggiornaDatiAzienda,
    };

    try {
      // 5. Chiamata API (Usiamo lastValueFrom per attendere la risposta)
      const esito = await lastValueFrom(
        this.reportVsmeService.postCreazioneReportVsmeStep1(formVsmeAndAzienda),
      );

      // 6. Valorizzazione post-salvataggio
      this.idQuestionario = esito?.idQuestionario;
      this.formReportVsme.get('id')?.setValue(esito?.id ?? this._idReportCorrente);

      // Disabilitazione form
      this.infoFormVsmeCMP.formInfoVsme.disable();
      this.formReportVsme.disable();

      // Se ho un id data source allora lo imposto per il widget FOLLIA
      if (esito?.idDatasourceAi) {
        this.widgetStore.setIdDatasourceAi(esito.idDatasourceAi);

        // mostro snackbar caricamento file
        this.widgetStore.fileLoadingRecursive();
      } else if (!esito?.idDatasourceAi && this.isIntegrazioneAI) {
        this.utilityService.openSnackBar(
          "Non sono stati scelti documenti per il supporto dell'intelligenza artificiale ",
          'OK',
          {
            panelClass: ['red-snackbar'],
          },
        );
      }

      // Gestione errore parziale (ma successo tecnico)
      if (esito?.folliaStatus === 'PARTIAL_CONTENT') {
        this.utilityService.openDialog({
          titolo: 'Report VSME creato parzialmente',
          descrizione: esito?.folliaErrorMessage ?? 'Report VSME creato parzialmente',
          bottoni: [{ nome_btn: 'Ok' }],
        });
      }

      // 7. Reperisco il genetic prompt
      await this.getGenericPrompt();

      return true;
    } catch (err: any) {
      // 8. Gestione errore chiamata
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: err?.error?.message || 'Si è verificato un errore durante il salvataggio.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return false;
    }
  }

  ctrCampiAziendaCambiati(): string[] {
    const campiCambiati: string[] = [];

    const formAggiornata = this.infoFormVsmeCMP.formInfoVsme.getRawValue() as InfoFormVsme;
    const dati = this._datiAzienda as any;
    const tabellaSiti = this.infoFormVsmeCMP.tabellaSitiCmp.salva();

    if (
      this.datiAziendaVsme?.tipoAzienda !== this.formReportVsme.get('tipoAzienda')?.getRawValue()
    ) {
      campiCambiati.push('Tipo Azienda');
    }

    if (dati?.fatturato !== this.formReportVsme.get('fatturato')?.getRawValue()) {
      campiCambiati.push('Fatturato');
    }
    if (dati?.dipendenti !== this.formReportVsme.get('nrDipendenti')?.getRawValue()) {
      campiCambiati.push('Numero Dipendenti');
    }
    if (dati?.codiciNace?.[0] !== formAggiornata.codiciNace?._id) {
      campiCambiati.push('Codice NACE');
    }

    if ((dati?.formaGiuridica?.[0] ?? '') !== (formAggiornata.formaGiuridica?.[0] ?? '')) {
      campiCambiati.push('Forma Giuridica');
    }

    if (dati?.paeseOperazioni?.[0] !== formAggiornata.paeseOperazioni?.countryCode) {
      campiCambiati.push('Paese Operazioni');
    }

    if (dati?.statoPatrimoniale !== formAggiornata.statoPatrimoniale) {
      campiCambiati.push('Stato Patrimoniale');
    }

    if (
      dati?.tabellaSiti?.colonne.length != tabellaSiti?.colonne.length ||
      dati?.tabellaSiti?.righe.length != tabellaSiti?.righe.length
    ) {
      campiCambiati.push('Tabella Siti');
    } else {
      const celleModificate = tabellaSiti?.righe.some((rigaUpd, indiceRiga) => {
        const celleRiga = rigaUpd.celle[rigaUpd.id];
        const celleDati = dati?.tabellaSiti.righe[indiceRiga].celle[rigaUpd.id];

        // Controlla se almeno una cella è diversa
        return Object.keys(celleRiga).some((chiaveCella) => {
          return celleRiga[chiaveCella] !== celleDati[chiaveCella];
        });
      });

      if (celleModificate) {
        campiCambiati.push('Tabella Siti');
      }
    }

    return campiCambiati;
  }

  async ctrDatiAziendaChanged(): Promise<boolean> {
    const campiCambiati = this.ctrCampiAziendaCambiati();

    const id = this.formReportVsme.get('id')?.value;

    if (!id && campiCambiati.length) {
      const listaHTML = `
    <ul style="margin-top: 4px; margin-bottom: 4px;">
      ${campiCambiati.map((campo) => `<li><strong>${campo}</strong></li>`).join('')}
    </ul>
  `;

      const dialog = this.utilityService.openDialog({
        titolo: 'Variazione Dati Azienda',
        descrizione: `Sono stati modificati i seguenti campi appartenenti all'azienda:${listaHTML} Vuoi procedere con l'<strong>aggiornamento</strong>?`,
        fontWeight: 'normal',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   *  get informative aziendali
   */
  private _getInformativa() {
    const id = this.formReportVsme.get('id')?.value;
    if (id) {
      this.spinnerOver.show();
      this.reportVsmeService
        .getInformativa(id)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (risp) => {
            this.arrayInformativa = [risp];
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  compilazione(elemento: any) {
    const id = this.formReportVsme.get('id')?.value;
    if (id) {
      this.spinnerOver.show();
      this.reportVsmeService
        .getCompilazioneInformativa(id)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (compila) => {
            const dialogCompilaInformativaAziendale = this.dialog.open(
              DialogAnteprimaCompilazioneInfoAzComponent,
              {
                data: {
                  infoAz: compila,
                  inConf: elemento.stato === 'VERDE' || this.isPermessoSoloReadFunx(),
                },
                panelClass: ['dialog-container'],
                disableClose: false,
                width: '90%',
                height: '90%',
                maxWidth: '90%',
                autoFocus: false,
              },
            );

            dialogCompilaInformativaAziendale.afterClosed().subscribe((event) => {
              const statoCompilatoInChiusura = event?.info;
              const isBozza = event?.isBozza;

              if (statoCompilatoInChiusura) {
                // Sono in bozza ovvero non ho compilato tutte le domande
                if (isBozza) {
                  this.spinnerOver.show();

                  this.reportVsmeService
                    .putSalvaCompilazioneInformativaBozza(id, statoCompilatoInChiusura)
                    .pipe(finalize(() => this.spinnerOver.hide()))
                    .subscribe({
                      next: () => {
                        this._getInformativa();
                      },
                      error: (err) => {
                        this.utilityService.openDialog({
                          titolo: 'Attenzione',
                          descrizione: err?.error?.message || 'Errore salva compilazione',
                          bottoni: [{ nome_btn: 'Ok' }],
                        });
                        console.error(err);
                      },
                    });

                  // Sono in compilazione intera quindi pubblico
                } else {
                  this.spinnerOver.show();

                  this.reportVsmeService
                    .putSalvaCompilazioneInformativa(id, statoCompilatoInChiusura)
                    .pipe(finalize(() => this.spinnerOver.hide()))
                    .subscribe({
                      next: () => {
                        this._getInformativa();
                      },
                      error: (err) => {
                        this.utilityService.openDialog({
                          titolo: 'Attenzione',
                          descrizione: err?.error?.message || 'Errore salva compilazione',
                          bottoni: [{ nome_btn: 'Ok' }],
                        });
                        console.error(err);
                      },
                    });
                }
              }
            });
          },
          error: (err) => {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err?.error?.message || 'Errore Generico',
              bottoni: [{ nome_btn: 'Ok' }],
            });
            console.error(err);
          },
        });
    }
  }

  figura(elemento: any) {
    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: { id: elemento.id },
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogAssociaFiguraAziendale.afterClosed().subscribe((idFiguraNuova) => {
      const idFiguraPrecedente = elemento?.id;

      if (this.idReportVsme && idFiguraPrecedente && idFiguraNuova) {
        this.reportVsmeService
          .putCambiaFiguraInformativa(this.idReportVsme, idFiguraNuova)
          .subscribe({
            next: () => {
              this._getInformativa();
            },
            error: (err) => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: err?.error?.message || 'Errore Generico',
                bottoni: [{ nome_btn: 'Ok' }],
              });
              this._getInformativa();
              console.error(err);
            },
          });
      }
    });
  }

  inviaMailInformativa(elemento: any) {
    this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: 'Confermi di inviare la mail?',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            const id = this.formReportVsme.get('id')?.value;
            if (id) {
              this.spinnerOver.show();

              this.reportVsmeService.inviaMailInformativa(id).subscribe({
                next: () => {
                  this.spinnerOver.hide();
                  this._getInformativa();
                },
                error: (err) => {
                  this.spinnerOver.hide();
                  this.utilityService.openDialog({
                    titolo: 'Attenzione',
                    descrizione: err?.error?.message || 'Errore Generico',
                    bottoni: [{ nome_btn: 'Ok' }],
                  });
                },
              });
            }
          },
        },
      ],
    });
  }

  inviaNotifInformativa(elemento: any) {
    this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: 'Confermi di inviare la notifica?',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            const id = this.formReportVsme.get('id')?.value;
            if (id) {
              this.spinnerOver.show();

              this.reportVsmeService.inviaNotificaInformativa(id).subscribe({
                next: () => {
                  this.spinnerOver.hide();
                  this._getInformativa();
                },
                error: (err) => {
                  this.spinnerOver.hide();
                  this.utilityService.openDialog({
                    titolo: 'Attenzione',
                    descrizione: err?.error?.message || 'Errore Generico',
                    bottoni: [{ nome_btn: 'Ok' }],
                  });
                },
              });
            }
          },
        },
      ],
    });
  }

  /**
   * Metodo di stampa per l'ìnformativa aziendale
   */
  protected stampaInformativa() {
    this.spinnerOver.show();

    this.reportVsmeService
      .postStampaInforamtiva(this.idReportVsme)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (urlStampa: any) => {
          window.open(urlStampa?.body, '_blank');
        },
        error: (err: any) => {
          console.error(err);

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Stampa non riuscita. Verificare le configurazioni e riprovare.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  /**
   * Se l'informativa è consigliata allora controllo che sia stata compilata, altrimenti ritorno un messaggio di avviso
   */
  public async isInformativaCompilata(): Promise<boolean> {
    if (this.arrayInformativa.length && !this.isArchiviato()) {
      if (!this.arrayInformativa.some((info) => info.statoQuestionario === 'PUBBLICATO')) {
        const descrizione = 'La compilazione delle informazioni non è necessaria ma è consigliata';
        if (!(await this.openDialogPerStdr(descrizione))) {
          return false;
        }
      }
    }
    return true;
  }

  async openDialogPerStdr(descrizoine: string): Promise<boolean> {
    const dialog = this.utilityService.openDialog({
      titolo: 'Informativa Aziendale',
      descrizione: descrizoine,
      fontWeight: 'normal',
      bottoni: [
        {
          nome_btn: 'Chiudi',
          id_btn: 'C',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'Avanti',
          id_btn: 'A',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    return valDialog !== 'C';
  }

  private _getStepTematiche() {
    const id = this.formReportVsme.get('id')?.value;

    const idSettore = (this.formReportVsme.get('settori')?.value as Settore).id;
    this.componenteSurvey.datiInizialiCfgQuestionario(idSettore);

    if (!id) {
      return;
    }

    this.spinnerOver.show();

    this._getQuestionarioReportVsme().subscribe({
      next: (reportVsme: any) => {
        if (reportVsme) {
          this._reportVsme = reportVsme;
          this.completaStep();
        }
        this._abilitaBottoneAvanti();
        this.spinnerOver.hide();
      },
      error: (err: any) => {
        console.error(err);
        this._abilitaBottoneAvanti();

        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero della reportVsme',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      },
    });
  }

  /**
   * Metodo che mi fa la get del questionario di reportVsme
   * @param id id ReportVsme
   * @returns
   */
  private _getQuestionarioReportVsme() {
    if (!this.idReportVsme) {
      return of(false);
    }

    return this.reportVsmeService
      .getQuestionarioReportVsme(this.idReportVsme)
      .pipe(
        catchError((err) => {
          console.error(err);
          if (err.status === 404) {
            return of(false);
          } else {
            return throwError(() => err);
          }
        }),
      )
      .pipe(
        map((reportVsme) => {
          if (reportVsme) {
            this._reportVsme = reportVsme;
          }
          return reportVsme;
        }),
      );
  }

  /**
   * Viene richiamato nel momento in cui si caricano le tamatiche (questionario)
   */
  public completaStep() {
    if (this.isPubblicato() || this.isArchiviato()) {
      this.stepper.steps.forEach((step, idx) => {
        step.completed = true;
      });
    }
  }
  /**
   * Metodo salvataggio STEP  TEMATICHE
   * @returns
   */
  public async salvaStepTematiche(): Promise<boolean> {
    if (this.componenteSurvey.ctrSalva()) {
      return false;
    }

    return new Promise<boolean>((resolve) => {
      if (this.componenteSurvey.stato === 'PUBBLICATO') {
        resolve(true);
        return;
      }

      this.componenteSurvey.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }

  private async _getDatiCompilazioneTematiche(): Promise<boolean> {
    if (!this.idReportVsme) {
      return false;
    }

    const mapReport = (reportVsme: any) => ({
      ambiti: reportVsme.ambiti,
      stato: reportVsme.stato,
      tipo: reportVsme.tipo,
      idAzienda: reportVsme.idAzienda,
      tipoAzienda: reportVsme.tipoAzienda,
    });

    this.spinnerOver.show();

    try {
      const reportVsme = await firstValueFrom(
        this._getQuestionarioReportVsme().pipe(finalize(() => this.spinnerOver.hide())),
      );

      if (reportVsme) {
        this.compilaTematiche = mapReport(reportVsme);
        this._abilitaBottoneAvanti();
        return true;
      } else {
        this._abilitaBottoneAvanti();
        return false;
      }
    } catch (err) {
      console.error(err);
      this._abilitaBottoneAvanti();
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero del questionario',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return false;
    }
  }

  finitaCompilazione(value: boolean) {
    if (value) {
      this.stepper.next();
    }
  }

  /* --------------- C R U S C O T T O ---------------- */

  public fnCaricamentoDatiCruscotto: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (this.idReportVsme) {
      return this.reportVsmeService.getCruscotti(
        this.idReportVsme,
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      );
    } else {
      return of(false);
    }
  };

  /**
   * TOTALI CRUSCOTTO STEP 9
   * @param idReportVsme
   */

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.modificaFigura(event.data);
        break;
      case 'compila':
        this.eleCompilazioneFigura(
          event.data.elementi,
          event.data.nome,
          event.data.figura,
          event.data.id,
        );

        break;
      case 'azione':
        if (event.data) {
          if (event.data.ultimoInvio) {
            this._inviaNotificaSingola(event.data);
          } else {
            this._inviaMailSingola(event.data);
          }
        }
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Modifica figura su cruscotto
   * @param dati
   */
  modificaFigura(dati: any) {
    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: { id: dati.id },
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogAssociaFiguraAziendale.afterClosed().subscribe((idFiguraNuova) => {
      const idFiguraPrecedente = dati?.id;

      if (this.idReportVsme && idFiguraPrecedente && idFiguraNuova) {
        this.reportVsmeService
          .putCambiaFigura(this.idReportVsme, idFiguraPrecedente, idFiguraNuova)
          .subscribe({
            next: () => {
              this.tabellaCruscotto.caricaDati();
            },
            error: (err) => {
              this.tabellaCruscotto.caricaDati();
              console.error(err);
            },
          });
      }
    });
  }

  private async _inviaMailSingola(cruscotto: any) {
    if (this.idReportVsme) {
      const testiMail = await firstValueFrom(
        this.reportVsmeService.getTemplateMail(this.idReportVsme),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Invia mail ',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.reportVsmeService.inviaMail(this.idReportVsme, cruscotto.id));
        await firstValueFrom(this._getQuestionarioReportVsme());
        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Mail inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio mail',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  /**
   * Metodo che mi invia una notifica singola
   * @param cruscotto
   * @returns
   */
  private async _inviaNotificaSingola(cruscotto: any) {
    if (this.idReportVsme) {
      const testiMail = await firstValueFrom(
        this.reportVsmeService.getTemplateMail(this.idReportVsme),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica alla figura selezionata',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();

        await firstValueFrom(this.reportVsmeService.inviaNotifica(this.idReportVsme, cruscotto.id));
        await firstValueFrom(this._getQuestionarioReportVsme());

        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Notifica inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio notifica',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  async notificaTutti() {
    if (this.idReportVsme) {
      const testiMail = await firstValueFrom(
        this.reportVsmeService.getTemplateMail(this.idReportVsme),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica a tutte le figure che hanno ricevuto la mail',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.reportVsmeService.inviaNotificaMultiple(this.idReportVsme));
        await firstValueFrom(this._getQuestionarioReportVsme());

        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Notifica inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio notifiche',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  async inviaTutti() {
    if (this.idReportVsme) {
      const testiMail = await firstValueFrom(
        this.reportVsmeService.getTemplateMail(this.idReportVsme),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      if (this._reportVsme.stato !== 'PUBBLICATO' && this._reportVsme.stato !== 'ARCHIVIATO') {
        const risultatoObservable = await this._pubblicazioneReportVsme("con l'invio mail");
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
        this.spinnerOver.hide();
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.reportVsmeService.inviaMailMultiple(this.idReportVsme));
        await firstValueFrom(this._getQuestionarioReportVsme());
        this.tabellaCruscotto.caricaDati();
        this.utilityService.openSnackBar('Mail inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio mail',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  template() {
    if (this.idReportVsme) {
      const dialogCreaTemplateMail = this.dialog.open(DialogCreaTemplateMailComponent, {
        data: {
          idModulo: this.idReportVsme,
          tipoModulo: 'REPORT_VSME',
          isPermessoSoloRead: this.isPermessoSoloReadFunx(),
        },
        panelClass: 'dialog-container-scrollbar',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCreaTemplateMail.afterClosed().subscribe();
    }
  }

  /**
   *
   * @param elementiCruscotto
   * @param nome
   * @param figura
   */
  public async eleCompilazioneFigura(
    elementiCruscotto: ElementiCruscotto[],
    nome: string,
    figura: string,
    idFigura: string,
  ) {
    if (this.idReportVsme) {
      if (!this.isPubblicato() && !this.isPermessoSoloReadFunx()) {
        /* --- Modifica richiesta: Se ci sono elementi precompilati lo posso sapere solamente se pubblico 
          il questionario, una volta pubblicato, il BE calcola le precompilazioni, mi rifaccio la get del cruscotto filtrato
          per idFigura selezionata e mi reperisco gli elementi aggiornati e precompilati. --- */

        const risultatoObservable = await this._pubblicazioneReportVsme('alla compilazione');
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
          try {
            // CHIAMO LA FIGURA FILTRTA E ASPETTO RISPOSTA
            const figura: any = await this.getFiguraCruscotto(idFigura, this.idReportVsme);
            elementiCruscotto = figura?.content[0]?.elementi;
          } catch (err) {
            console.error(err);
          }
        }
        this.spinnerOver.hide();
      }

      const dialogCompilazioneFigure = this.dialog.open(DialogCompilazioneFigureComponent, {
        data: {
          elementiCruscotto,
          idReportVsme: this.idReportVsme,
          nome,
          figura,
          isPermessoSoloRead: this.isPermessoSoloReadFunx(),
        },
        panelClass: ['dialog-container'],
        disableClose: false,
        width: '75%',
        maxHeight: '95%',
        maxWidth: '90%',
        autoFocus: false,
      });

      dialogCompilazioneFigure
        .afterClosed()
        .pipe(
          switchMap(() => {
            this.spinnerOver.show();
            return this._getQuestionarioReportVsme();
          }),
        )
        .subscribe(() => {
          this.tabellaCruscotto.caricaDati();
          this.spinnerOver.hide();
          this.cmpTotaliCruscotto.getTotaliCruscotto();
        });
    }
  }

  /**
   * Get cruscotto filtrato per figura
   * @param idFigura
   * @param idReportVsme
   * @returns
   */
  getFiguraCruscotto(idFigura: string, idReportVsme: string) {
    return new Promise((resolve, reject) => {
      let filtroFiguraSelezionata: Filters = {
        values: [idFigura],
        operator: 'eq',
        chiave: 'id',
      };

      this.reportVsmeService
        .getCruscotti(idReportVsme ?? '', 0, 1000, '', [filtroFiguraSelezionata])
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(new Error(err)),
        });
    });
  }

  private async _pubblicazioneReportVsme(desc?: string): Promise<Observable<boolean> | undefined> {
    let titolo: string = `Attenzione`;
    let descrizione: string = `
      <div>
        <p>
          Procedendo alla compilazione non potrai più modificare le selezioni <br> effettuate nella scheda <strong>Informativa VSME</strong> per ognuna delle tematiche selezionate.
        </p>
        <p><strong>Vuoi procedere ${desc ?? ' '}?</strong></p>
      </div>
    `;

    const dialog = this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      fontWeight: '500',
      bottoni: [
        { nome_btn: 'No', id_btn: 'N' },
        { nome_btn: 'Si', id_btn: 'S' },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return of(false);
    }

    // PUBBLICO IL report vsme E ASPETTO LA RISPOSTA
    this.spinnerOver.show();

    await firstValueFrom(this.reportVsmeService.pubblicaReportVsme(this.idReportVsme!));
    if (this._reportVsme?.stato) {
      this._reportVsme.stato = 'PUBBLICATO';
    }
    this._gestioneStatoSteps(true);
    return of(true);
  }

  /* ------------------------- STAMPA -------------------------*/

  public async stampa() {
    this.spinnerOver.show();
    await this.cmpTotaliCruscotto.getTotaliCruscotto();
    this.spinnerOver.hide();

    if (
      this.cmpTotaliCruscotto.isElementiNonCompilati(['TABELLE', 'KPI', 'AZIONI', 'RISPOSTETESTO'])
    ) {
      let titolo: string = 'Stampa';
      let descrizione: string = `
      <div>
        <p>
          Non sono state <strong>completate</strong> tutte le <strong>compilazioni</strong>.
        </p>
        <p><strong>Vuoi procedere?</strong></p>
      </div>`;

      const dialog = this.utilityService.openDialog({
        titolo: titolo,
        descrizione: descrizione,
        fontWeight: '500',
        bottoni: [
          { nome_btn: 'No', id_btn: 'N' },
          { nome_btn: 'Si', id_btn: 'S' },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return of(false);
      }
    }

    if (!this.cfgStampaComponent.cfgStampa) {
      console.error('NESSUNA CFG STAMPA DA SALVARE');
      return;
    }

    this.spinnerOver.show();

    const idReport = this.idReportVsme;

    if (idReport && this.cfgStampaComponent.cfgStampa) {
      this.fnSalvaCfgStampa(this.cfgStampaComponent.cfgStampa)
        .pipe(
          switchMap((result: any) => {
            if (result) {
              return this.reportVsmeService.postStampaReportVsme(idReport);
            } else {
              return of();
            }
          }),
        )
        .subscribe({
          next: (urlStampa: any) => {
            window.open(urlStampa?.body, '_blank');

            this.spinnerOver.hide();
          },
          error: (err: any) => {
            console.error(err);

            this.spinnerOver.hide();

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Stampa non riuscita. Verificare le configurazioni e riprovare.',
              bottoni: [{ nome_btn: 'Ok' }],
            });
          },
        });
    }
    return of();
  }

  /**
   * Lancia il salvataggio della configurazione, passando dal componente.
   */
  public salvaCfgStampa() {
    if (!this.cfgStampaComponent.cfgStampa) {
      console.error('NESSUNA CFG STAMPA DA STAMPARE');
      return;
    }

    this.spinnerOver.show();

    this.fnSalvaCfgStampa(this.cfgStampaComponent.cfgStampa).subscribe((esito: any) => {
      if (!esito) {
        // Salvataggio fallito
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione:
            'Salvataggio configurazione non riuscito. Verificare le informazioni e riprovare.',
          bottoni: [{ nome_btn: 'Ok' }],
        });
      }

      this.spinnerOver.hide();
    });
  }

  /**
   *
   * @returns Funzione di get cfg stampa da impostare sul componente cfgStampaComponent
   */
  public fnGetConfigStampa = () => {
    if (!this.idReportVsme) {
      return throwError(() => 'ID ReportVsme non valorizzato');
    }

    return this.reportVsmeService.getConfigStampa(this.idReportVsme);
  };

  /**
   * Funzione di salvataggio cfg stampa da impostare sul componente cfgStampaComponent
   * @param grpCfgStampa
   * @returns
   */
  public fnSalvaCfgStampa = (grpCfgStampa: GruppoCfgStampa) => {
    if (!this.idReportVsme) {
      return throwError(() => 'ID ReportVsme non valorizzato');
    }

    if (this.isPermessoSoloReadFunx()) {
      return of(true);
    }

    return this.reportVsmeService.postSalvaElementiStampa(this.idReportVsme, grpCfgStampa);
  };

  /**
   * Metodo che mi fa l'importazione del file immagine
   * @param elemStampa
   */
  public fnImportaImmagine = (file: File, chiaveCfg: string) => {
    if (!this.formReportVsme.get('idAzienda')?.value || !this.idReportVsme) {
      return throwError(() => 'DATI INSUFFICIENTI PER ELIMINAZIONE IMMAGINE');
    }

    const listaId = {
      idAzienda: this.formReportVsme.get('idAzienda')!.value,
      idReprtVsme: this.idReportVsme,
      chiaveCfg,
    };

    return this.importazioniService.importImgStampaReportVsme(file, {}, listaId);
  };

  /**
   * Metodo per eliminazione immagine in cfg stampa
   * Viene rimosso da google cloud storage
   */
  public fnEliminaImg = (chiaveCfg: string) => {
    if (!this.formReportVsme.get('idAzienda')?.value || !this.idReportVsme) {
      return throwError(() => 'DATI INSUFFICIENTI PER ELIMINAZIONE IMMAGINE');
    }

    const listaId = {
      idAzienda: this.formReportVsme.get('idAzienda')!.value,
      idReprtVsme: this.idReportVsme,
      chiaveCfg,
    };

    return this.importazioniService.deleteImgStampaReportVsme(listaId);
  };

  public toggleLoading(mostra: boolean) {
    if (mostra) {
      this.spinnerOver.show();
    } else {
      this.spinnerOver.hide();
    }
  }
  /*--------------------- STATO STEPPER ---------------------------- */

  /**
   * Gestione stato stepper per il tasto avanti, quindi linear
   */
  private _gestioneStatoStepperAvanti() {
    const step = this.stepper.steps.get(this.stepper.selectedIndex);

    if (!this.isPubblicato() && !this.isArchiviato() && step) {
      step.completed = true;

      if (this.stepper.selectedIndex === 0) {
        step.editable = false;
      }
    }
  }

  /**
   * Se ho un modulo pubblicato, inserisco l'icona "check" su tutti gli stepper
   * Per visualizzare l'icona check devo mettere completed = true; e editable = false;
   */
  private _gestioneStatoSteps(pubblicato?: boolean) {
    if (this.isPubblicato() || pubblicato || this.isArchiviato()) {
      this.stepper.steps.forEach((step, index) => {
        step.completed = true;
        step.editable = false;
      });
    }
  }

  /**
   * Helper function che mi fa la navigazione
   * Devo mettere [editable = true] altrimenti non mi funziona la navigazione indietro
   * Poi lo rimetto a [false], per visualizzare l'icona del "check".
   * Se lo lasciasi a [true], con completed = true, mi visualizzerebbe l'icona della matita
   * @param index indice di spostamento dello step
   */
  private _moveInStep(index: number) {
    const step = this.stepper.steps.get(index);
    if (step) {
      step.editable = true;
      this.stepper.selectedIndex = index;
      step.editable = false;
    }
  }

  /**
   * Metodo che gestisce la logica della navigazione sugli stepper
   */
  gestioneStepper() {
    setTimeout(() => {
      /* CONTROLLI DI NAVIGAZIONE */
      this.stepper.steps.forEach((step, idx) => {
        step.select = async () => {
          /* SALTO I CONTROLLI E NAVIGO DIRETTAMENTE */
          if (this.saltaCtrStepper(idx)) {
            this._moveInStep(idx);
            return;
          }

          const isCompleted = this.stepper.steps.get(idx)?.completed;
          const isLinearNext = idx === this.stepper.selectedIndex + 1;

          /* SE NAVIGO E HO STEP INTERMEDI, esmepio da step 1, direttamente a step 4, devo controllare step 2-3 */
          if (isCompleted) {
            const validIndex = await this.ctrStep(idx);
            this._moveInStep(validIndex);
            return;
          }

          /* SONO IN NAVIGAZIONE LINEARE, step by step */
          if (isLinearNext) {
            const isSaved = await this.avanti();
            if (isSaved) {
              this._gestioneStatoStepperAvanti();
              this.stepper.selectedIndex = idx;
              return;
            }
          }
        };
      });
    }, 0);
  }

  /**
   * Salto controllo e vado dritto alla navigazione
   * @param idx
   * @returns true = salto controlli
   */
  saltaCtrStepper(idx: number): boolean {
    if (this.isPermessoSoloReadFunx()) {
      return true;
    }

    if (this.isPubblicato() || this.isArchiviato()) {
      return true;
    }

    // Se torno indietro non faccio ne controlli ne salvataggi
    if (idx < this.stepper.selectedIndex) {
      return true;
    }
    return false;
  }

  /**
   * gestione controlli step selezionati
   * @param stepperSelezionato
   * @returns
   */
  private async ctrStep(stepperSelezionato: number): Promise<number> {
    const stepperCorrente = this.stepper.selectedIndex;

    if (stepperSelezionato > stepperCorrente) {
      for (let index = stepperCorrente; index < stepperSelezionato; index++) {
        // Salvo step corrente
        if (stepperCorrente === index) {
          const isSalvato = await this.avanti();
          if (!isSalvato) {
            return stepperCorrente;
          } else {
            continue;
          }
        }

        // Controllo step by step e ritorno l'index dove da errore
        if (await this.ritornoControllo(index)) {
          return index;
        }
      }
    }

    return stepperSelezionato;
  }

  /**
   * Controlli degli stepper
   * @param stepperDaControllare
   * @returns true => Controllo step fallito
   */
  private async ritornoControllo(stepperDaControllare: number): Promise<boolean> {
    let isCtrFallito: boolean = false;
    switch (stepperDaControllare) {
      case 2:
        isCtrFallito = this.componenteSurvey.ctrSalva();
        break;

      case 3: {
        const esito = await this._getDatiCompilazioneTematiche();
        if (esito) {
          if (this.cmpCompilaVsme.moveToTematicaSenzaRisposte()) {
            this.utilityService.openSnackBar(
              'Seleziona almeno una informativa VSME per ogni tematica. Se si vuole escludere una tematica dal report, rimuoverla nello step 3: Tematiche e procedere.',
              '',
              {
                duration: 8000,
                panelClass: ['red-snackbar'],
              },
            );
            isCtrFallito = true;
          }
        }
        break;
      }

      default:
        break;
    }
    return isCtrFallito;
  }
  /*--------------------------------- FINE STATO STEPPER ---------------------------------------- */

  public disabilitaBtnTematicaNext(): boolean {
    const isRispostaPresente =
      !!this.cmpCompilaVsme.ambiti[this.cmpCompilaVsme.indexAmbitoCorrente].tematiche[
        this.cmpCompilaVsme.indexTematicaCorrente
      ].risposte?.length;

    if (!isRispostaPresente && !this.isPubblicato() && !this.isArchiviato()) {
      return true;
    }

    return false;
  }

  avantiTematica() {
    if (!this.disabilitaBtnTematicaNext()) {
      this.cmpCompilaVsme.avanti();
    } else {
      this.utilityService.openSnackBar('Seleziona almeno una risposta', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
    }
  }

  private ctrIsUtenteGo() {
    this._subTema = this.temaService.temaUpdated.subscribe((tipoInstallazione) => {
      if (tipoInstallazione === 'SOSTENIBILE_GO') {
        this.isUtenteGo = true;
      } else {
        this.isUtenteGo = false;
      }
    });
  }

  protected openSelezioneDocumenti() {
    const selectedFolderIds: string[] = this.formReportVsme.get('selectedFolderIds')?.getRawValue();
    const dialogPromptAi = this.dialog.open(DialogSelezioneDocumentiPerAiComponent, {
      data: { idModulo: this.idReportVsme, selectedFolderIds: selectedFolderIds },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      height: '95%',
      autoFocus: false,
    });

    dialogPromptAi
      .afterClosed()
      .subscribe((result: { isSaved: boolean; idMainFoldersSelected: string[] }) => {
        if (result?.isSaved) {
          this.formReportVsme.get('selectedFolderIds')?.setValue(result.idMainFoldersSelected);
        }
      });
  }

  /**
   * Mi ritorna il prompt generico per modulo.
   * @returns
   */
  async getGenericPrompt(): Promise<boolean> {
    if (!this.idReportVsme || !this.isIntegrazioneAI) return false;

    this.spinnerOver.show();
    try {
      const result: any = await firstValueFrom(
        this.reportVsmeService.getGenericPrompt(this.idReportVsme),
      );

      if (!result) return false;

      this.widgetStore.setPromptModulo(result?.result);

      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.spinnerOver.hide();
    }
  }
}
